import { Company } from '../models';
import { useDocument } from './useDocument';

export function useCompany(id: string | 'new' = 'new') {
  return useDocument<Company>('Companies', id);
}
